import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import { HeaderCommonProps } from "@components/Header/types";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { useWindowSize } from "@hooks/useWindowSize";
import MyAccountLoginProfile from "@routes/MyAccount/components/MyAccountLoginProfile";
import MyAccountLogin from "@routes/MyAccount/components/MyAccountLoginTrigger";
import MyAccountPopover from "@routes/MyAccount/components/MyAccountPopover/MyAccountPopover";
import { cn } from "@util/helpers";

type MyAccountUserHeaderProps = Pick<
  HeaderCommonProps,
  "textClassName" | "userIconStrokeColor"
>;

export default function MyAccountUserHeader({
  textClassName,
  userIconStrokeColor,
}: MyAccountUserHeaderProps): React.ReactElement {
  const { loginId } = useUserInfo();
  const { isScreenLG } = useWindowSize();

  if (isScreenLG)
    return (
      <MyAccountPopover
        textClassName={textClassName}
        userIconStrokeColor={userIconStrokeColor}
      />
    );

  return (
    <div
      className="relative flex-none"
      data-testid="my-account-header-mobile-component"
    >
      {loginId ? (
        <Link
          to={RouteFactory.myAccount}
          reloadDocument
          className={cn(
            "relative mr-2 flex h-8 w-8 items-center justify-center rounded-full border border-gray-175 p-3 font-poppins text-2xs font-semibold leading-none tracking-tightest text-gray-850 duration-300 lg:hover:bg-gray-250",
            textClassName,
            userIconStrokeColor
          )}
        >
          <MyAccountLoginProfile
            firstCharOfLogin={loginId.charAt(0).toUpperCase()}
          />
        </Link>
      ) : (
        <MyAccountLogin />
      )}
    </div>
  );
}
